import {
  GET_SEARCH_PTUK_REQUEST,
  GET_SEARCH_PTUK_SUCCESS,
  GET_SEARCH_PTUK_ERROR
} from "./types";
import axios from "axios";
import { BASEURL } from "../../constant/config.js";
import moment from "moment";

export const searchPTUK = (token, values) => (dispatch) => {
  dispatch({ type: GET_SEARCH_PTUK_REQUEST });
  const newData = {
    pt_no: values.sku
};
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/SearchPTUKData`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: newData
  })
    .then((response) => {
      return dispatch({
        type: GET_SEARCH_PTUK_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_SEARCH_PTUK_ERROR,
        payload: [],
      });
    });
};
